import { ResponseReuseType } from '../constants';
import { Task } from '../interfaces';

export const checkIfRRAppliedButNotFullRR = (tasks: Task[]): boolean => {
  let partialRRButNotFullRR = false;
  let fullRRCount = 0;
  for (let i = 0; i < tasks.length; i++) {
    const task = tasks[i];
    if (
      task.responseReuseType === ResponseReuseType.PARTIAL_RR ||
      task.responseReuseType === ResponseReuseType.FULL_RR
    ) {
      partialRRButNotFullRR = true;
    }
    if (task.responseReuseType === ResponseReuseType.FULL_RR) ++fullRRCount;
  }
  if (fullRRCount === tasks.length) partialRRButNotFullRR = false;

  return partialRRButNotFullRR;
};
